import ShareOutlinedIcon from '@portalterreno/react-ui-icons/ShareOutlinedIcon';

import withDropdownHandler, {
  WithDropdownHandlerProps
} from '../withDropdownHandler';
import StyledList from './StyledList';
import StyledShareButton from './StyledShareButton';
import StyledWrapper from './StyledWrapper';

export type ShareButtonMobileProps = WithDropdownHandlerProps;

const ShareButtonMobile: React.FC<ShareButtonMobileProps> = ({
  handleOpenList,
  isShareListOpen,
  wrapperRef,
  ...rest
}) => {
  return (
    <StyledWrapper
      ref={wrapperRef}
      {...rest}
    >
      <StyledShareButton
        left={<ShareOutlinedIcon />}
        size='small'
        color='secondary'
        onClick={handleOpenList}
      />
      {isShareListOpen && <StyledList />}
    </StyledWrapper>
  );
};
export default withDropdownHandler(ShareButtonMobile);
